import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { buildQuery } from '../../Service/os'
import {
  DetalheEvento,
  EntradaSimulador,
  EstudoPrevisoes,
  PainelPrevisoes,
  ResultadoSimulador,
  SimuladorOpcoes,
} from '../../types/previsoes'

const BASE = 'producer/analytics'

// O snapshot muda uma vez por dia (cron da madrugada): sem revalidar ao focar a aba.
const OPCOES = { revalidateOnFocus: false, dedupingInterval: 5 * 60 * 1000 }

/**
 * Painel do dia (ou da data de referência pedida): carteira, lotes, GMV e
 * qualidade, mais os números fixos do estudo (vêm mesmo sem snapshot).
 */
export const usePrevisoes = (referencia?: string) => {
  const url = `${BASE}/getPrevisoes?${buildQuery({ referencia })}`
  const { data, error, isLoading } = useSWR(url, () => APIDecoratorWithBaseURI().get(url), OPCOES)
  const body = data?.data?.body
  return {
    painel: (body?.painel ?? undefined) as PainelPrevisoes | undefined,
    referencias: (body?.referencias ?? []) as string[],
    estudo: (body?.estudo ?? undefined) as EstudoPrevisoes | undefined,
    /** carregou e ainda não há snapshot gravado */
    vazio: !isLoading && !error && data !== undefined && !body?.painel,
    isLoading,
    isError: error,
  }
}

/** Detalhe de um evento: curva, comparáveis e lotes. */
export const usePrevisaoEvento = (id?: number, referencia?: string) => {
  const url = id ? `${BASE}/getPrevisoesEvento?${buildQuery({ id, referencia })}` : null
  const { data, error, isLoading } = useSWR(url, () => APIDecoratorWithBaseURI().get(url as string), OPCOES)
  return {
    detalhe: data?.data?.body as DetalheEvento | null | undefined,
    isLoading,
    isError: error,
  }
}

/** Listas do formulário do simulador (base fixa do estudo). */
export const useSimuladorOpcoes = () => {
  const url = `${BASE}/getPrevisoesSimuladorOpcoes`
  const { data, error, isLoading } = useSWR(url, () => APIDecoratorWithBaseURI().get(url), {
    ...OPCOES,
    dedupingInterval: 60 * 60 * 1000,
  })
  return { opcoes: data?.data?.body as SimuladorOpcoes | undefined, isLoading, isError: error }
}

/** Uma simulação (chamada sob demanda, no botão Simular). */
export const simularPrevisao = async (e: EntradaSimulador): Promise<ResultadoSimulador> => {
  const query = buildQuery({
    ...e,
    localId: e.localId ?? undefined,
    produtorId: e.produtorId ?? undefined,
    nome: e.nome || undefined,
    artistas: e.artistas.join('|') || undefined,
  })
  const r = await APIDecoratorWithBaseURI().get(`${BASE}/simularPrevisao?${query}`)
  return r.data.body as ResultadoSimulador
}
